/**
 * errors.js
 * Shared API error handling utility.
 * Location: client/src/utils/errors.js
 *
 * Replaces the duplicated if/else status-code chains in dashboardService,
 * profileService, and any other service files.
 *
 * Usage:
 *   import { handleApiError } from "../../utils/errors";
 *   catch (error) { throw handleApiError(error, "dashboard stats"); }
 */

/**
 * Maps an axios error response to a user-facing Error with a meaningful message.
 * Always throws — use inside a catch block.
 *
 * @param {Error} error - The caught axios error
 * @param {string} context - Brief description of what was being fetched e.g. "dashboard stats"
 * @returns {Error} A new Error with a descriptive message
 */
export const handleApiError = (error, context) => {
  switch (error.response?.status) {
    case 401:
      return new Error("Authentication required");
    case 403:
      return new Error("Access forbidden");
    case 404:
      return new Error(`${context ? `${context} ` : ""}not found`);
    case 500:
      return new Error("Server error occurred");
    default:
      return new Error(`Failed to fetch ${context || "data"}`);
  }
};
